import React from "react"
import { Player, BigPlayButton, LoadingSpinner, ControlBar } from "video-react"
import { Container } from "./style"
import "video-react/dist/video-react.css"

const VideoPlayer = ({ url = "" }) => {
  return (
    <Container>
      <Player
        aspectRatio="4:3"
        playsInline
        poster="/assets/poster.png"
        src={url}
        height="100%"
      >
        <LoadingSpinner />
        <ControlBar />
        <BigPlayButton position="center" />
      </Player>
    </Container>
  )
}

export default VideoPlayer
